module.exports = __webpack_public_path__ + "img/benefit-card-2-tablet.2e7485b4.png";